import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSearchBar } from '../features/SearchBar';
import { closeNavMenu } from '../features/NavMenu';

const SearchButton = () => {
  const dispatch = useDispatch();
  const searchBar = useSelector((state) => state.searchBar.value);

  return (
    <button
      className={`p-1 text-2xl rounded bg-[#eef2ff] text-[#34345c] border ${
      searchBar.isOpen ? 'border-[#34345c]' : 'border-[#eef2ff]'
    }`}
      onClick={() => {
        dispatch(toggleSearchBar());
        dispatch(closeNavMenu());
      }}
    >
      <FaSearch />
    </button>
  );
};

export default SearchButton;
